jQuery(document).ready(function($){
    /** FORM SUBMIT */
    if(typeof acf === 'undefined')
        return;
    
    acf.add_filter('validation_complete', function( json, $form ){

        var fields_file = $form.find('div.acf-field-file');

        for (var index = 0; index < fields_file.length; index++) {

            var min_size    = fields_file[index].dataset.minSize;
            var max_size    = fields_file[index].dataset.maxSize;
            var acf_key     = fields_file[index].dataset.key;
            var input       = $(fields_file[index]).find('input[id]');
            var error       = false;

            if(input[0].files.length){
                var file_size =  input[0].files[0].size;
                var file_size_mb =  file_size / 1024 / 1024;
                var temp_errors = {};

                if( max_size && (file_size_mb > max_size) )
                {
                    temp_errors.input = 'acf[' + acf_key + ']';
                    temp_errors.message = "La taille maximale de fichier autorisé est de " + max_size + "MB";
                    error = true;
                }

                if( min_size && (file_size_mb < min_size) )
                {
                    temp_errors.input = 'acf[' + acf_key + ']';
                    temp_errors.message = "La taille minimale de fichier autorisé est de " + min_size + "MB";
                    error = true;
                }

                if(error){
                    if(json.valid){
                        json.valid = 0;
                        json.errors = [];
                    }

                    json.errors.push(temp_errors);
                }

            }
            
        }

        
        if( !json.errors ) {

            var btn = $form.find('button[type="submit"]');

            btn.after('<span>Envoi en cours..</span>')

            btn.hide();

            //btn.find('span.title').text('Envoie en cours..');
/*             acf.disableSubmit(btn);
            btn.on('click', function(e){
                e.preventDefault();
            })

            btn.disabled = true; */

            //btn.prop("type", "button");
            
            // lock form
            //acf.lockForm( $form );
            //btn[0].disabled = true;
        }
        
        // return
        return json;        
    });

    
   // console.log('dtlayer.js OK');

    /** FORM SUBMIT */
   // if(typeof acf === 'undefined')
   //   return;
    

    /*acf.addAction('submit', function($form) {

        var formid = $($form).attr("id");
        var userid = ga.getAll()[0].get('clientId');

        if (formid == 'elivie_apply_form') {

            var event = 'spontaneous-apply-form';

        } else if (formid == 'elivie_event_form') {

            var event = 'event-form';

        } else if (formid == 'elivie_contact_form') { 

            var event = 'contact-form';
            var store_name = $(".acf-field-5d3182411687d .dropdown-selected span").text();
            var user_type = $("input[name='acf[field_5d4ada45df9d7]']:checked").val();
            var other = $(".acf-field-5d4adad8df9d8 .dropdown-selected span").text();
        }


        if (formid == 'elivie_contact_form') {

            var vars = {
                'event': event,
                'user-id' : userid,
                'user-type': user_type,
                'store-name': store_name,
                'other' : other,
            };

        } else {

            var vars = {
                'event': event,
                'user-id' : userid,
            };

        }

        _trsb_tag_event(vars);

    });

    */
    /****FORM GOOGLE MAPS***/
    /*
    //SELECT AGENCE
    this.map = $('#vah_map');
    this.container = this.map.closest('.flex-contact-banner');

    this.container.find('.selector select').on('change', function (e) {

    var store = $(this).siblings(".dropdown-selected").find('.value').text();

    var vars = {
                'event': 'store-search',
                'store-name' : store,
            };

        _trsb_tag_event(vars);
    });  
*/
    /**********************************/
    //SEARCH ADRESS ON MapController.js
    /**********************************/
    
    // STORE CONTACT 
    $(document).on('click','.btn',function() {

        if(this.getAttribute('data-dl-store-name')){

            var vars = {
                'event': 'store-contact',
                'store-name': $(this).attr("data-dl-store-name"),
            };  
             
        _trsb_tag_event(vars);

        }
    });

    /* DATA LAYER CLICK */

    var links = document.querySelectorAll('a');

    links.forEach(function(link) {

        if(link.getAttribute('data-dl')){

            var vars={};

            link.addEventListener("click", function(){
                
                var dataAttributes =  link.attributes;
    
                for (var i = 0; i < dataAttributes.length; i++){
    
                    var expr = /^(data\-dl\-).+/;
                    var name = dataAttributes[i].nodeName;
                    var value = dataAttributes[i].nodeValue;
    
                    if(expr.test(name)){
                        if(name == "data-dl-link-url"){
                            if(value){
                              vars["link-url"] = value;
                            }else {
                              vars["link-url"] = link.href;
                            }
                        }else if(name == "data-dl-link-text"){
                            if(value){
                              vars["link-text"] = value;
                            }else {
                              vars["link-text"] = link.innerText;
                            }
    
                        }else{
                            var nameClean = name.replace(/data-dl-/g,'');
                            vars[nameClean] = value;
                        }
                    }
    
                }

                _trsb_tag_event(vars);
            });            

        }else {

            if($(link).parents('[data-wysiwyg-dl="true"]').length > 0){
                
                var parent = $(link).parents('[data-wysiwyg-dl="true"]');
                var vars={};

                link.addEventListener("click", function(){
        
                    var dataAttributes =  parent[0].attributes;
        
                    for (var i = 0; i < dataAttributes.length; i++){
        
                        var expr = /^(data\-dl\-).+/;
                        var name = dataAttributes[i].nodeName;
                        var value = dataAttributes[i].nodeValue;
        
                        if(expr.test(name)){
                            var nameClean = name.replace(/data-dl-/g,'');
                            vars[nameClean] = value;
                        }
                    }

                    vars["link-text"] = link.innerText;
                    vars["link-url"] = link.href;

                    _trsb_tag_event(vars);
                });                
            }
        }
    });
    

    /* DATA LAYER SCROLL DISPLAY */

    var ticking = false;

    window.addEventListener('scroll', function (e) {

        if (!ticking) {
            window.requestAnimationFrame(function () {
                initWhenYouCan();
                ticking = false;
            });
        }
        ticking = true;
    });

});

function _trsb_tag_event(vars){
    window.dataLayer = dataLayer || [];
    dataLayer.push(vars);
}

function initWhenYouCan() {
    var elemnts = document.querySelectorAll('[data-display-dl="false"]');

    elemnts.forEach(function (element) {

        if (isElementInViewport(element)) {
            var dataAttributes =  element.attributes;
            var vars={};

            for (var i = 0; i < dataAttributes.length; i++){

                var expr = /^(data\-display\-dl\-).+/;
                var name = dataAttributes[i].nodeName;
                var nameClean = name.replace(/data-display-dl-/g,'');
                var value = dataAttributes[i].nodeValue;

                if(expr.test(name)){
                    vars[nameClean] = value;
                }
            }

            vars["event"] = "display";
            _trsb_tag_event(vars);
            element.setAttribute("data-display-dl", "true");
        }

    });
}


function isAnyPartOfElementInViewport(el) {
    var rect = el.getBoundingClientRect();

    // DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
    var windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    var windowWidth  = (window.innerWidth  || document.documentElement.clientWidth);

    // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
    var vertInView = (rect.top  <= windowHeight) && ((rect.top + rect.height) >= 0);
    var horInView  = (rect.left <= windowWidth)  && ((rect.left + rect.width) >= 0);

    return (vertInView && horInView);
}

function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document. documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document. documentElement.clientWidth)
    );
}
